import { render, staticRenderFns } from "./error-p.vue?vue&type=template&id=59e58240&scoped=true&"
import script from "./error-p.vue?vue&type=script&lang=js&"
export * from "./error-p.vue?vue&type=script&lang=js&"
import style0 from "./error-p.vue?vue&type=style&index=0&id=59e58240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e58240",
  null
  
)

export default component.exports